import { useCallback, useState } from "react";
import { useApi } from "../../utils/Api";

export function useBankIdApi() {
  const api = useApi();

  const postBankIdInitialization = useCallback(
    (startAuthenticationUrl, request, token, fetchStatusIncludeCredentials) => {
      return api.fetch(startAuthenticationUrl, request, "POST", token, true, false, fetchStatusIncludeCredentials);
    },
    [api],
  );

  const safeGetBankIdTransactionStatus = useCallback(
    async (statusUrl, token, fetchStatusIncludeCredentials) => {
      const failedStatus = "failed";
      const genericBankIdError = "bankIdUnspecifiedError";
      try {
        const bankIdStatusResponse = await api.fetch(
          statusUrl,
          null,
          "GET",
          token,
          true,
          false,
          fetchStatusIncludeCredentials,
        );

        if (bankIdStatusResponse?.isSuccessful === false) {
          return { status: failedStatus, hintCode: genericBankIdError, ...bankIdStatusResponse };
        }
        return bankIdStatusResponse ?? { status: failedStatus, hintCode: genericBankIdError };
      } catch {
        return { status: failedStatus, hintCode: genericBankIdError };
      }
    },
    [api],
  );

  const postBankIdCancelTransaction = useCallback(
    (bankIdCancelUrl, token, fetchStatusIncludeCredentials) => {
      return api.fetch(bankIdCancelUrl, null, "POST", token, true, false, fetchStatusIncludeCredentials);
    },
    [api],
  );

  const [bankIdApi] = useState({
    postBankIdInitialization,
    safeGetBankIdTransactionStatus,
    postBankIdCancelTransaction,
  });

  return bankIdApi;
}
